import { Link } from "react-router-dom";

const footerLinks = {
  product: [
    { label: "Signal", href: "/technical-brief" },
    { label: "Reputation", href: "/technical-brief" },
    { label: "Relationship", href: "/technical-brief" },
    { label: "Pricing", href: "/pricing" },
    { label: "Simulator", href: "/simulator" },
  ],
  trust: [
    { label: "Neutrality Promise", href: "/neutrality-promise" },
    { label: "GDPR", href: "/privacy" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Executive Summary", href: "/executive-summary" },
  ],
  developers: [
    { label: "API Reference", href: "/docs/integrate" },
    { label: "Integration Guide", href: "/docs/integrate" },
    { label: "Technical Brief", href: "/technical-brief" },
    { label: "Glossary", href: "/what-is" },
    { label: "Blog", href: "/blog" },
    { label: "Hash Specification", href: "/technical-brief" },
  ],
};

const Footer = () => {

  return (
    <>

      <footer className="relative overflow-hidden border-t border-border">
        {/* Four-column links */}
        <div className="border-t border-border">
          <div className="container mx-auto px-6 py-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {/* Brand column */}
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="relative h-6 w-6">
                    <svg viewBox="0 0 100 100" className="h-full w-full">
                      <defs>
                        <linearGradient id="logoGradFooter" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="hsl(190 100% 50%)" />
                          <stop offset="100%" stopColor="hsl(210 70% 50%)" />
                        </linearGradient>
                      </defs>
                      <g transform="translate(10, 30) scale(0.36)">
                        <path
                          d="M40 55 C40 25 90 25 110 55 C130 85 180 85 180 55 C180 25 130 25 110 55 C90 85 40 85 40 55 Z"
                          fill="none"
                          stroke="url(#logoGradFooter)"
                          strokeWidth="18"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </div>
                  <span className="font-semibold text-foreground">ClearSlot</span>
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  Infrastructure for the industry that feeds the world.
                </p>
              </div>

              {/* Product */}
              <div>
                <p className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Product</p>
                <ul className="space-y-2">
                  {footerLinks.product.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Trust */}
              <div>
                <p className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Trust</p>
                <ul className="space-y-2">
                  {footerLinks.trust.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Developers */}
              <div>
                <p className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">Developers</p>
                <ul className="space-y-2">
                  {footerLinks.developers.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div className="border-t border-border bg-card/50">
          <div className="container mx-auto relative flex flex-col items-center gap-4 px-6 py-6 md:flex-row md:justify-between">
            <div className="flex items-center gap-2">
              <span className="text-sm text-muted-foreground">ClearSlot</span>
            </div>

            <p className="text-sm text-muted-foreground text-center md:absolute md:left-1/2 md:-translate-x-1/2">
              © ClearSlot 2026. All rights reserved.
            </p>

            <div className="flex gap-6 text-sm text-muted-foreground">
              <Link to="/blog" className="transition-colors hover:text-foreground">Research</Link>
              <Link to="/privacy" className="transition-colors hover:text-foreground">Privacy</Link>
              <Link to="/terms" className="transition-colors hover:text-foreground">Terms</Link>
              <a href="mailto:hello@clearslot.io" className="transition-colors hover:text-foreground">Contact</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
